import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, ModuleWithProviders } from '@angular/core';
import { BlockUIModule } from 'ng-block-ui';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { NgxPermissionsModule } from 'ngx-permissions';
import { OverlayModule } from '@angular/cdk/overlay';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CommonModule } from '@angular/common';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { DataService } from '../Shared/services/data.service';
import { UtilityService } from '../Shared/services/UtilityService';
import { ErrorMassageValidation } from '../Shared/services/validationErrorMassage.service';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { DateInputComponent } from './DateTimePicker/DateTimePicker.component';
import { FileUploadComponent } from './FileUplaod/FileUplaod.component';
import { MultiLingualTextBoxComponent } from './MultiLingualTextBox/MultiLingualTextBox.component';
import { TextboxComponent } from './TextBox/Textbox.component';
import { ControlUtility } from '../Shared/services/ControlUtility';
import { TextAreaComponent } from './TextArea/TextArea.component';
import { MultiLingualTextAreaComponent } from './MultiLingualTextArea/MultiLingualTextArea.component';
import { CheckBoxComponent } from './CheckBox/CheckBox.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DropdownListComponent } from './DropdownList/DropdownList.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { PhoneComponent } from './Phone/Phone.component';
import { ToggleslideComponent } from './Toggleslide/toggleslide.component';
import { MatSlideToggleModule } from '@angular/material';
import { HtmlEditorComponent } from './HtmlEditor/HtmlEditor.component';
import { NgxSummernoteModule } from 'ngx-summernote';
import { MultiLingualHtmlEditorComponent } from './MultiLingualHtmlEditor/MultiLingualHtmlEditor.component';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { TooltipModule } from '@syncfusion/ej2-angular-popups';
import { FileUploadModule } from 'ng2-file-upload';
import { MultipleFileUploadComponent } from './MultipleFileUplaod/MultipleFileUplaod.component';
import { ImageUploaderComponent } from './ImageUpload/ImageUpload.component';
// import { NgxDropzoneModule } from 'ngx-dropzone';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProfileImageUploaderComponent } from './ProfileImageUploader/ProfileImageUploader.component';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
// import { FullCalendarModule } from '@fullcalendar/angular';
// import { CalendarComponent } from './Calendar/Calendar.component';
import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';
import { AgmCoreModule } from '@agm/core';
import { MapAutoCompleteComponent } from './MapAutoComplete/MapAutoComplete.component';
import { NgxTypeaheadModule } from 'ngx-typeahead';
import { AutocompleteTextBoxComponent } from './AutocompleteTextBox/AutocompleteTextBox.component';
import { NgxTagsInputModule } from 'ngx-tags-input';
import { TagsInputComponent } from './TagsInput/TagsInput.component';
import { PagingComponent } from './Paging/Paging.component';
import { JwPaginationComponent } from './Paging/JwPagination.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { OnPagingFiltersChangeService } from '../Shared/services/OnPagingFiltersChange.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { RadioButtonComponent } from './RadioButton/RadioButton.component';
import { BrowserModule } from '@angular/platform-browser';
import { environmentService } from '../Shared/services/environmentService.Service';

export let options: Partial<IConfig> | (() => Partial<IConfig>);

export let AppInjector: Injector;

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}

@NgModule({
  declarations: [

    DateInputComponent,
    FileUploadComponent,
    MultiLingualTextBoxComponent,
    TextboxComponent,
    TextAreaComponent,
    MultiLingualTextAreaComponent,
    CheckBoxComponent,
    DropdownListComponent,
    PhoneComponent,
    ToggleslideComponent,
    HtmlEditorComponent,
    MultiLingualHtmlEditorComponent,
    // MultiLingualHtmlEditorComponent,
    MultipleFileUploadComponent,
    ImageUploaderComponent,
    ProfileImageUploaderComponent,
    //CalendarComponent,
    MapAutoCompleteComponent,
    AutocompleteTextBoxComponent,
    TagsInputComponent,
    PagingComponent,
    JwPaginationComponent,
    RadioButtonComponent
  ],
  imports: [

    InfiniteScrollModule,
    NgSelectModule,
    NgxTagsInputModule,
    NgxTypeaheadModule,
    AgmCoreModule.forRoot(),

    // AgmCoreModule.forRoot({
    //   // &language=${UtilityService.CurrentLanguage}
    //   apiKey: `AIzaSyDaqLzsDywi8RgZNDd1sFqOzRFWHr-ZSWM`,
    //    libraries: ['places'],
    // }),
    //MatGoogleMapsAutocompleteModule,
    // FullCalendarModule,
    AngularCropperjsModule,
    NgbModule,
    // NgxDropzoneModule,
    FileUploadModule,
    TooltipModule,
    NgxMaskModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    NgxSummernoteModule,
    MatSlideToggleModule,
    NgxIntlTelInputModule,
    AngularMultiSelectModule,
    NgMultiSelectDropDownModule.forRoot(),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    CommonModule,
    BlockUIModule.forRoot(),
    ReactiveFormsModule,
    HttpModule,
    RouterModule,
    ToastrModule.forRoot(),
    HttpClientModule,
    NgxPermissionsModule.forRoot(),
    OverlayModule,
    StoreDevtoolsModule.instrument(),
    FormsModule,
    NgxIntlTelInputModule,
    NgxIntlTelInputModule,
    BsDatepickerModule.forRoot(),
    // FullCalendarModule
  ],
  providers: [
    DataService,
    UtilityService,
    ErrorMassageValidation,
    ControlUtility,
    OnPagingFiltersChangeService
  ],
  schemas: [
    NO_ERRORS_SCHEMA
  ],

  exports: [

    DateInputComponent,
    FileUploadComponent,
    MultiLingualTextBoxComponent,
    TextboxComponent,
    TextAreaComponent,
    MultiLingualTextAreaComponent,
    CheckBoxComponent,
    DropdownListComponent,
    PhoneComponent,
    ToggleslideComponent,
    HtmlEditorComponent,
    MultiLingualHtmlEditorComponent,
    // MultiLingualHtmlEditorComponent,
    MultipleFileUploadComponent,
    ImageUploaderComponent,
    ProfileImageUploaderComponent,
   // CalendarComponent,
    MapAutoCompleteComponent,
    AutocompleteTextBoxComponent,
    TagsInputComponent,
    PagingComponent,
    JwPaginationComponent,
    RadioButtonComponent
  ]
})
export class BnsightsLibraryModule {

  constructor(private injector: Injector, private translate: TranslateService) {
    AppInjector = this.injector;
    translate = UtilityService.Translator;


  }
  static forRoot(memberData): ModuleWithProviders {
    return {
      ngModule: BnsightsLibraryModule,
      providers: [DataService,
        UtilityService,
        ErrorMassageValidation,
        ControlUtility,
        OnPagingFiltersChangeService, environmentService, { provide: 'BaseUrl', useValue: memberData }]
    };
  }

  //    static setDynamicProviders(BaseUrl:any) {
  //     environmentService.setBaseUrl(BaseUrl)
  //     return BnsightsLibraryModule;
  // }

  //  static forChild(BaseUrl?:string): ModuleWithProviders<BnsightsLibraryModule> {
  //   environmentService.setBaseUrl(BaseUrl)
  //   return {
  //     ngModule: BnsightsLibraryModule,
  //     providers: [ 
  //        DataService,
  //       UtilityService,
  //       ErrorMassageValidation,
  //       ControlUtility
  //     ],

  //   };
  // }
}
